/*
NOTE: this file only temporarily resides in scratch-gui.
Nearly identical code appears in scratch-www, and the two should
eventually be consolidated.
*/

import classNames from "classnames";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

import MenuBarMenu from "./menu-bar-menu.jsx";
import { MenuSection } from "../menu/menu.jsx";
import MenuItemContainer from "../../containers/menu-item.jsx";
import UserAvatar from "./user-avatar.jsx";
import dropdownCaret from "./dropdown-caret.svg";
import ChangePasswordModal from "./change-password-modal.jsx"; // Import the new modal

import styles from "./account-nav.css";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min.js";
import userApi from "@/api/module/user";
import { Modal } from "antd";

const { confirm } = Modal;
const AccountNavComponent = ({
    className,
    isOpen,
    isRtl,
    menuBarMenuClassName,
    onClick,
    onClose,
    thumbnailUrl,
}) => {
    const history = useHistory();
    const [userInfo, setUserInfo] = useState({});
    const [isChangePasswordModalVisible, setIsChangePasswordModalVisible] =
        useState(false);

    const showChangePasswordModal = () => {
        setIsChangePasswordModalVisible(true);
    };

    const handleModalOk = () => {
        setIsChangePasswordModalVisible(false);
        // You can add logic here to refresh user data if needed
    };

    const handleModalCancel = () => {
        setIsChangePasswordModalVisible(false);
    };

    const onLogOut = () => {
        confirm({
            title: "提示",
            content: "是否退出登录",
            okText: "确定",
            cancelText: "取消",
            onOk() {
                history.replace("/login");
                document.cookie =
                    "Admin-Token=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";
                document.cookie =
                    "auth_token=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";
                return Promise.resolve();
            },
        });
    };

    const getUserInfo = () => {
        try {
            userApi.getUserInfo(({ data }) => {
                if (data.data?.id) {
                    setUserInfo(data.data);
                    localStorage.setItem("userInfo", JSON.stringify(data.data));
                }
            });
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getUserInfo();
    }, []);

    return (
        <React.Fragment>
            <div
                className={classNames(styles.userInfo, className)}
                // onMouseUp={onClick}
            >
                <UserAvatar
                    className={styles.avatar}
                    imageUrl={require("@/assets/imgs/avatar.png")}
                />
                <span className={styles.profileName}>
                    {userInfo?.username || "-"}
                </span>
                {/* <div className={styles.dropdownCaretPosition}>
                    <img
                        className={styles.dropdownCaretIcon}
                        src={dropdownCaret}
                    />
                </div> */}
            </div>
            <MenuBarMenu
                className={menuBarMenuClassName}
                open={isOpen}
                // note: the Rtl styles are switched here, because this menu is justified
                // opposite all the others
                place={isRtl ? "right" : "left"}
                onRequestClose={onClose}
            >
                <MenuItemContainer
                    onClick={showChangePasswordModal} // Open modal on click
                >
                    修改密码
                </MenuItemContainer>
                <MenuSection>
                    <MenuItemContainer onClick={onLogOut}>
                        退出登录
                    </MenuItemContainer>
                </MenuSection>
            </MenuBarMenu>
            <ChangePasswordModal
                visible={isChangePasswordModalVisible}
                onOk={handleModalOk}
                onCancel={handleModalCancel}
            />
        </React.Fragment>
    );
};

AccountNavComponent.propTypes = {
    className: PropTypes.string,
    classroomId: PropTypes.string,
    isEducator: PropTypes.bool,
    isOpen: PropTypes.bool,
    isRtl: PropTypes.bool,
    isStudent: PropTypes.bool,
    menuBarMenuClassName: PropTypes.string,
    onClick: PropTypes.func,
    onClose: PropTypes.func,
    onLogOut: PropTypes.func,
    profileUrl: PropTypes.string,
    thumbnailUrl: PropTypes.string,
    username: PropTypes.string,
};

export default AccountNavComponent;
